<template>
  <div class="contactus">
    <banner img="../assets/img/bgtop.jpg" title="联系我们" />
	<el-row class="contact-box">
		<el-col :span="24">
			<!-- <div class="slide-five-left">
			  <img src="../assets/img/ercode.jpg" alt />
			  <span>扫码关注官方微信公众号</span>
			</div> -->
			<div class="company">江西通慧科技集团股份有限公司（总部）</div>
			<div class="slide-five-right">
				<p><i class="el-icon-message"></i> 电子邮箱：jxth@jxth.com</p>
				<p><i class="el-icon-phone"></i>
					联系电话：0791-86613192 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 传真：0791-83801732<br/>
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					业务联系：13642114255 (吕先生) 结构物健康监测
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					13387087883 (林先生) 智慧工地
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  
					13207919992 (陶先生) 智慧交通</p>
				<p>
					<i class="el-icon-location-information"></i> 
					公司地址：江西省南昌经济技术开发区瑞香路900号通慧科技大厦
				</p>
			</div>
		</el-col>
		<el-col :span="24">
			<baidu-map class="bm-view" :center="siteStartX" :zoom="13">
				<bm-local-search :keyword="keyword" :auto-viewport="true" :location="location"></bm-local-search>
				<bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
				<bm-marker :position="siteStartX" animation="BMAP_ANIMATION_BOUNCE">
					<bm-label
					  content="江西省南昌经济技术开发区<br/>瑞香路900号通慧科技大厦"
					  :offset="{width:20,height:0}"
					  :position="siteStartX"
					  title="江西通慧科技集团股份有限公司"
					/>
				</bm-marker>
			</baidu-map>
		</el-col>
	</el-row>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  name: "contactus",
  components: {
    Banner
  },
  data() {
    return {
		siteStartX: { // 经纬度
		  lng: 115.809362, lat: 28.726494,
		},
		location: '南昌',
		keyword: '通慧科技集团股份有限'
    };
  },
  created() {

  },
  mounted() {

  },
  methods: {

  }
};
</script>

<style lang="scss" scoped>
.contactus {
  width: 100%;
  height: 100%;
  //联系我们
  .company{
	  color: #000000;
	  font-size: 20px;
	  font-weight: bolder;
	  margin-bottom: 15px;
  }
  .contact-box{
  	width: 1200px;
  	margin: 0px auto;
  	padding: 50px 0px;
  	// border-bottom: 1px solid #FFFFFF;
  }
  .slide-five-left{
  	width: 600px;
  	float: left;
  	text-align: center;
  	img{
  		width: 150px;
  		border-radius: 5px;
  	}
  	span{
  		display: inline-block;
  		width: 100%;
  		color: #999;
  		font-size: 15px;
  	}
  }
  .slide-five-right{
  	padding-top: 10px;
  	font-size: 18px;
  	color: #666;
  	float: left;
  	p{
  		margin-bottom: 15px;
  	}
  	i{
  		font-size: 22px;
  		vertical-align: middle;
		color: #000000;
		margin-right: 10px;
  	}
  }
  .bm-view {
  	width: 100%;
  	height: 400px;
	margin-top: 20px;
	margin-bottom: 150px;
  }
}
</style>